import { authTokenStorage } from '~/gateways/auth/authTokenStorage';
import { MagicUseCase } from '../magicUseCase';

export class LogOutUseCase extends MagicUseCase {
  protected async runLogic(path?: string) {
    authTokenStorage.clearAuthToken();
    this.getState().resetState();
    if (path) {
      this.navigate(`/tenants/auth/signin?redirect=${path}`);
      return;
    }
    this.navigate('/tenants/auth/signin');
  }
}
